import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import { TextInputField } from '@havenengineering/module-shared-library/dist/form/components/TextInput';
import useForm, {
  createRegexValidator,
  emailValidator,
} from '@havenengineering/module-shared-library/dist/form/hooks/useForm';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import { formErrorHandling } from '../../../helpers/googleTag';
import { getRefundType } from '../../../helpers/refund';
import { RefundForm } from '../../../types/refund';

type AccountStepForm = Pick<RefundForm, 'accountNumber' | 'email' | 'mobile'>;
interface AccountStepProps {
  state: RefundForm;
  handleStepChange: (changedForm: AccountStepForm) => void;
}

export const Account: FunctionComponent<AccountStepProps> = ({
  state,
  handleStepChange,
}) => {
  const router = useRouter();
  const isLettingIncomeRefund = router.query.type === 'letting-income';

  const { fields, submit } = useForm<AccountStepForm>({
    initialState: {
      accountNumber: state?.accountNumber || '',
      email: state?.email || '',
      mobile: state?.mobile || '',
    },
    schema: {
      accountNumber: {
        required: true,
        validator: createRegexValidator(
          /^[a-zA-Z]{2,2}[0-9]{6,6}$/,
          'Account number must contain 2 letters and 6 numbers without any spaces'
        ),
      },
      email: {
        required: true,
        validator: [
          emailValidator,
          createRegexValidator(
            /^((?!haven.com|bourne-leisure.co.uk).)*$/,
            'haven.com and bourne-leisure.co.uk email addresses are not allowed'
          ),
        ],
      },
      mobile: {
        required: true,
      },
    },
    submitCallback: async (state) => {
      handleStepChange(state);
    },
    errorCallback: (fields) => {
      const errors = Object.keys(fields).map((key: string) => {
        const field = fields[key as keyof AccountStepForm];
        return {
          getErrorMessage: () => field.error,
          props: {
            name: field.name,
            label: '',
          },
        };
      }) as any[];
      formErrorHandling(getRefundType(isLettingIncomeRefund), errors);
    },
  });

  return (
    <form onSubmit={(event) => event.preventDefault()}>
      <TextInputField
        id="accountNumber"
        label="Account Number"
        field={fields.accountNumber}
        type="text"
      />
      <TextInputField
        id="email"
        label="Email Address"
        field={fields.email}
        type="text"
      />
      <TextInputField
        id="email"
        label="Contact Number"
        field={fields.mobile}
        type="text"
      />
      <Button type="submit" fullWidth onClick={() => submit()}>
        Continue
      </Button>
    </form>
  );
};
